import React from "react";
import PropTypes from "prop-types";
import CheckboxGroupContainer from "../../../shared/components/fields/checkboxes/CheckboxGroupContainer";

const CheckboxConfigField = ({
    values,
    maxChecked,
    handleFieldChange,
    hasSelectAll,
    title
}) => {
    return(
        <div className="row checkbox-config-field">
            <CheckboxGroupContainer
                values={values}
                maxChecked={maxChecked}
                handleFieldChange={handleFieldChange}
                hasSelectAll={hasSelectAll}
                title={title}
            />
        </div>)
};

CheckboxConfigField.propTypes = {
    values: PropTypes.object,
    maxChecked: PropTypes.number,
    handleFieldChange: PropTypes.func,
    hasSelectAll: PropTypes.bool,
    title: PropTypes.string
};

export default CheckboxConfigField;